import React from 'react'
import { Card, Row, Col } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';

const ComplementoAerolineasCargosResumen = ({ data = {} }) => {

  const renderCargos = (item) => (
    <RenderItems key={ item.CodigoCargo } data={ item } className="mb-2" />
  )

  return (
    <>
      { !!data.OtrosCargos &&  (
        <>
          <div className="d-block mt-3 mb-2">
            <strong>Otros Cargos</strong>
          </div>

          {data.OtrosCargos.Cargo.map(renderCargos)}
        </>
      ) }
    </>
  )
}

const RenderItems = ({ data = {} }) => {

  const renderLeyends = (item) => {
    return (
      <SingleLeyendLabel
        key={ item.index }
        label={ item.label }
        index={ item.index }
        data={ data }
        render={ item.render }
      />
    )
  }

  return (
    <Card className="mb-2">
      <Card.Body>
        <Row className="d-block mt-3 mb-2">
          <Col>
            { labels.map(renderLeyends) }
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

const labels = [
  {
    label: 'Código cargo',
    index: 'CodigoCargo'
  },
  {
    label: 'Importe',
    index: 'Importe',
  }
];

export default ComplementoAerolineasCargosResumen;
